export default "__VITE_ASSET__4af36d7f__"